import { Box, JustifyContent } from "@gocardless/flux-react";

import { marketingBackgroundColor } from "../consts";
import { SignUpAccountType } from "../SignUp";

import { SignUpFormComponent } from "./sign-up-form-component/SignUpFormComponent";
import { SignUpFormMarketing } from "./signup-form-marketing/SignUpFormMarketing";

import { VerticalSplitPageLayout } from "src/components/layout/VerticalSplitPage/VerticalSplitPageLayout";
import {
  ReferralEmailSource,
  ReferralEmailVariation,
} from "src/common/trackingEventAttributes";
import { CountryCodeSupported } from "src/common/country";
import { APILocale } from "src/technical-integrations/i18n";

export { SIGNUP_FORM_STORAGE_KEY } from "./sign-up-form-component/SignUpFormComponent";

const DEFAULT_COUNTRY_CODE = CountryCodeSupported.GB;

export interface SignUpFormProps {
  emailAddress: string;
  country: CountryCodeSupported;
  accountType: SignUpAccountType;
  referralGeo: string | null;
  referralCode: string | null;
  referralCodeName?: string | null;
  isPaymentProvider?: boolean;
  hasFsbMemberDiscount?: boolean;
  referralSource?: ReferralEmailSource | null;
  referralVariation?: ReferralEmailVariation | null;
}

export const SignUpForm = ({
  emailAddress,
  country,
  accountType,
  referralGeo,
  referralCode,
  isPaymentProvider,
  hasFsbMemberDiscount,
  referralCodeName,
  referralSource,
  referralVariation,
}: SignUpFormProps) => {
  const windowLanguage = window.navigator.language as APILocale;

  const browserLanguage =
    (windowLanguage &&
      (windowLanguage.split("-")[1] as CountryCodeSupported)) ||
    DEFAULT_COUNTRY_CODE;

  const language =
    country && Object.keys(CountryCodeSupported).includes(country)
      ? (country as CountryCodeSupported)
      : browserLanguage;

  return (
    <VerticalSplitPageLayout
      logoVariant="light"
      logoURL="https://gocardless.com"
      leftContent={
        <Box
          layout="flex"
          flexDirection="row"
          justifyContent={JustifyContent.Center}
        >
          <SignUpFormMarketing />
        </Box>
      }
      leftBackground={{
        backgroundColor: marketingBackgroundColor,
      }}
      rightContent={
        <Box
          width="100%"
          height="100%"
          layout="flex"
          justifyContent={[JustifyContent.Center]}
        >
          <SignUpFormComponent
            country={country}
            emailAddress={emailAddress}
            userNavigatorLocale={language}
            accountType={accountType}
            referralGeo={referralGeo}
            referralCode={referralCode}
            isPaymentProvider={isPaymentProvider}
            hasFsbMemberDiscount={hasFsbMemberDiscount}
            referralSource={referralSource}
            referralVariation={referralVariation}
            referralCodeName={referralCodeName}
          />
        </Box>
      }
    />
  );
};
